<!-- <div class="header d-flex align-items-center bg-s0">
  <app-image [src]="'./assets/images/STEMWerkzLogo.png'" [width]="'175px'" [height]="'42px'"></app-image>
</div> -->
<app-gift-fail *ngIf="!success" (onButtonClick)="backToGiftShop()"></app-gift-fail>
<app-gift-success *ngIf="success" [giftCard]="giftCardInfo" [homeUrl]="backToHomeUrl" (buyAnotherCardClick)="backToGiftShop()"></app-gift-success>
